

$(document).ready(function() {
  var custom_values = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    
  // be careful! FROM and TO should be index of values array
  var my_from = custom_values.indexOf(1);
  var my_to = custom_values.indexOf(10);

  
  $(".js-range-slider").ionRangeSlider({
    skin: "big",
      
      grid: true,
      from: my_from,
      to: my_to,
      values: custom_values,
      prettify_enabled: true,
   prettify_separator: ",",


  });

  
  $(".js-grid-text-0").addClass('active');

  $(".js-range-slider").on('change', function() {
    var $val = $(this).parents('.range__item').find('.irs-single').text();
    var $grid = ".js-grid-text-"+($val-1)
    $(this).parents('.range__item').find('.irs-grid-text').removeClass('active');
    $(this).parents('.range__item').find($grid).addClass('active');
  })
  
  

    
    $('.features-info-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    
        prevArrow:"<button type='button' class='slick-prev slick-prev--prev pull-left'><div class='js-slick-arrows' ></div></button>",
        nextArrow:"<button type='button' class='slick-next slick-next--next pull-right'><div class='js-slick-arrows' ></div></button>",
    
        
    });

    // $('.features-info-slider').slick({
    //     dots: false,
    //     infinite: false,
    //     speed: 300,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    
    //     prevArrow:"<div class='slick-prev slider-prev'><img class='arrow-right' src='./img/icons/arrow right.svg'><img  class='arrow-left' src='./img/icons/arrow left.svg'></div>",
    //     nextArrow:"<div class='slick-next slider-next'><img  class='arrow-right' src='./img/icons/arrow right.svg'><img  class='arrow-left' src='./img/icons/arrow left.svg'></div>",

    // });

    $('.features-video-slider').slick({
        dots: false,
        infinite: false,
        fade: true,
        cssEase: 'linear',
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:"<button type='button' class='slick-prev slick-prev--prev pull-left'><div class='js-slick-arrows' ></div></button>",
        nextArrow:"<button type='button' class='slick-next slick-next--next pull-right'><div class='js-slick-arrows' ></div></button>",
    });

    var cardLen =  $('.slider-card').length;
    
    
    for(var x=0; x<cardLen;x++) {
        var $item = $('.slider-card').eq(x).find('.slider-item').length;
       
        if($item > 3) {
            $('.slider-card').eq(x).find('.slider-item').removeClass('col-md-4 col-md-6 col-lg-4');
            $('.slider-card').eq(x).removeClass('div-top');
           
            $('.slider-card').eq(x).slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow:"<button type='button' class='slick-prev slick-prev--prev pull-left'><div class='js-slick-arrows' ></div></button>",
                nextArrow:"<button type='button' class='slick-next slick-next--next pull-right'><div class='js-slick-arrows' ></div></button>",

                responsive: [
                   
                    {
                      breakpoint: 767,
                      settings: {
                        dots: true,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        // prevArrow:"<button type='button' class='slick-prev slick-prev--prev pull-left'><div class='js-slick-arrows' ></div></button>",
                        // nextArrow:"<button type='button' class='slick-next slick-next--next pull-right'><div class='js-slick-arrows' ></div></button>",
                      }
                    },
                    
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
               
                
            });
            $('.slider-card').eq(x).find('.slick-list').addClass('div-top');
        }
    }

   

    

    setTimeout(function () {
        const players = Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
    }, 250);
    
})


$('.features-video-slider').on('beforeChange', function(event, slick, 
		currentSlide, nextSlide){
			$(this).parents("section").find('.features-info-slider').slick('slickGoTo', nextSlide)
			// $(this).parents("section").find('.educator-slider-profile').slick('slickGoTo', nextSlide)
	});

	$('.features-info-slider').on('beforeChange', function(event, slick, 
		currentSlide, nextSlide){
			$(this).parents("section").find('.features-video-slider').slick('slickGoTo', nextSlide)
	});


   

$(window).load(function() {
    
    var $secWidth = parseInt($('section').outerWidth());
    var bgWidth = ($secWidth/2)+"px";
    $('.program-tabs').find('.tab-bg').css({
        'width': bgWidth,
    })
});


$('.program-tabs__item').on('click', function() {
    $(this).addClass('active');
    var $index = $(this).attr('data-index');
    $(this).parents('.program-tabs').find('.program-tabs__item').not(this).removeClass('active');

    $('.programs-tab-content').find('.programs-tab-content__item').removeClass("active");

  $('.programs-tab-content').find('.programs-tab-content__item').eq($index).addClass("active");
    
});

$('.vartical-tab-list__item').on('click', function() {
    $(this).addClass('active');
    var $index = $(this).attr('data-index');
    $(this).parents('.vartical-tab-list').find('.vartical-tab-list__item').not(this).removeClass('active');

    $(this).parents('.vertical-tab').find('.vertical-tab-content').find('.vertical-tab-content__item').removeClass("active");

    $(this).parents('.vertical-tab').find('.vertical-tab-content').find('.vertical-tab-content__item').eq($index).addClass("active");
    
    $('.tab-item-mb').removeClass('active')
    $(this).find('.tab-item-mb').addClass('active');
    $("html, body").animate({ scrollTop: $(this).offset().top-170}, 500);
   
});


$('.vertcal-tab2-list__item').on('click', function() {
    var check = $(this).find('input');
    if(check.is(':checked')) {
       
        var $index = $(this).attr('data-index');
        console.log($index)
        $(this).addClass('active')
        $(this).parents('.vertcal-tab2-list').find('.vertcal-tab2-list__item').not(this).removeClass('active');
        $(this).parents('.vertcal-tab2').find('.vertcal-tab2-content').find('.vertcal-tab2-content__item').removeClass('active')
       var child =  $(this).parents('.vertcal-tab2').find('.vertcal-tab2-content').find('.vertcal-tab2-content__item').eq($index).addClass('active');
        $("html, body").animate({ scrollTop: $(child).offset().top-100}, 500);
    }
})

var counted = 0;
$(window).scroll(function() {

  var oTop = $('#counter').offset().top - window.innerHeight;
  if (counted == 0 && $(window).scrollTop() > oTop) {
    $('.count').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 1000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }

        });
    });
    counted = 1;
  }

});


$('body').on('click', '.js-find-pgm', function(e) {
  e.preventDefault();
  $(this).parents('.find-ideal-program').addClass('d-none');
  $(this).parents('.programs-tab-content__item').find('.selected-ideal-program').removeClass('d-none');
  $("html, body").animate({ scrollTop: $('.programs-tab-content').offset().top-170}, 500);
});


$('body').on('click', '.js-get-pgm', function(e) {
  e.preventDefault();
  $(this).parents('.programs-tab-content__item').find('.selected-ideal-program').addClass('d-none');
  $(this).parents('.programs-tab-content__item').find('.find-ideal-program').removeClass('d-none');
  $("html, body").animate({ scrollTop: $('.programs-tab-content').offset().top-170}, 500);
});